import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as settingAction from '../action/settingAction';
import * as helpAction from '../action/helpAction';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Material-ui
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import Checkbox from '@material-ui/core/Checkbox';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
//Part
import PartPageTitle from './PartPageTitle';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartCheckbox from './PartCheckbox';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import FilterListIcon from '@material-ui/icons/FilterList';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      filter: {
        outage: false,
        name: '',
      },
      filterOpen: false,
      page: 1,
      isListNext: false,
      delList: [],
      datetime: null,
    }
  }

  componentDidMount() {
    document.title = '表示しない会員 - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.state.datetime) {
      this._nondisplayListGet(this.state.filter, 1);
      window.scrollTo(0, 0);
    }
  }

  _paging(page) {
    this._nondisplayListGet(this.state.filter, page);
    window.scrollTo(0, 0);
  }

  _nondisplayListGet(filter, page) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    if (filter.outage === true) {
      params.append('outage', 1);
    }
    if (filter.name) {
      params.append('name', filter.name);
    }
    params.append('page', page);
    return axios.post(config.apiUri + "member/settingNondisplayListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      this.setState({
        list:res.data.list,
        page:page,
        isListNext:res.data.isListNext,
        date: (new Date()),
      });
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  _onChangeDelList(value) {
    let newDelList = Object.assign([], this.state.delList);
		let index = newDelList.findIndex((row) => row === value);
		if (index >= 0) {
			newDelList.splice( index, 1 );
		}
    else {
      newDelList.push(value);
    }
    this.setState({ delList: newDelList });
  }

  _filterEdit(outage, name) {
    this.setState({
      filter: {
        outage: outage,
        name: name.replace(/(　| )/g, ""),
      }
    });
  }

  _renderList(value, index, arr) {
    return (
      <div key={index}>

        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            padding:'3px',
          }}
        >
          <Checkbox
            onChange={ () => this._onChangeDelList(value.userdata_id_code) }
            checked={this.state.delList.includes(value.userdata_id_code)}
            color="primary"
          />


          <div style={{margin:'5px'}}>
            <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
              <PartUserName
                data={{
                  name: value.userdata_name,
                  sex: value.userdata_sex,
                  size: '1.2em',
                }}
              />
            </Link>
            <div style={{fontSize:'0.9em'}}>{ value.userdata_age }才 { value.userdata_prof_region }</div>
            <div style={{fontSize:'0.8em',color:'#666'}}>{ value.memo }</div>
          </div>

          <div style={{marginLeft:'auto', marginRight:'5px'}}>
            {
              (value.refusal === 1) && (
                <Chip label="ブロック済" variant="outlined" />
              )
            }
            {
              (value.userdata_attestation === 0) && (
                <Chip label="退会" variant="outlined" />
              )
            }
          </div>
        </div>


      </div>
    )
  }

  _delSubmit() {
    this.props.settingNondisplayDel(this.state.delList, () => {
      this._nondisplayListGet(this.state.filter, this.state.page);
      this.setState({ delList: [] });
    });
  }

  render() {
    return (
      <div>
        <PartPageTitle
          title={'表示しない会員'}
          onback={ '/setting/' }
          helpType={ 'category' }
          helpFilter={ 'hide' }
        />

        <div style={{maxWidth:'600px', margin:'auto'}}>
          <h3 align='center'> {this.props.my.setting.nondisplayCount} / { this.props.config.nondisplayLimit }</h3>

          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '10px',
            }}
          >
            <div>
              <IconButton
                onClick={ () => this.setState({filterOpen: true}) }
              >
                <FilterListIcon />
              </IconButton>
            </div>
            <div>
              <span style={{color:'#666'}}>ページ{this.state.page}</span>
              <IconButton
                onClick={ () => this._nondisplayListGet(this.state.filter, 1) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>

          {
            (this.state.list.length > 0) ? (
              <Box boxShadow={2} style={{background:'#FFF'}}>
                {
                  this.state.list.map(
                  	(value, index, arr) => this._renderList(value, index, arr)
                	)
                }
              </Box>
            ) : (
              <div style={{padding:'15px'}}>
                <h3 align='center'>表示しない会員はありません</h3>
              </div>
            )

          }
          <div style={{margin:'15px'}}>
            <PartPagingNextPrev
              page={this.state.page}
              isNext={this.state.isListNext}
              onClick={ (e) => this._paging(e) }
            />
          </div>
        </div>

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','hide') }
          >
            「表示しない」とは？
          </Button>
        </div>

        <Slide
          direction="up"
          in={(this.state.delList.length > 0 ? true: false)}
        >
          <div style={{position:'fixed',bottom:'10px',width:'100%',textAlign:'center'}}>
            <Fab
              color="primary"
              onClick={ () => this._delSubmit() }
              variant="extended"
            >
              <LockOpenIcon />
              表示しないを解除する
            </Fab>
          </div>
        </Slide>

        <Dialog
          fullScreen
          open={this.state.filterOpen}
          onClose={ () => this.setState({filterOpen: false}) }
          TransitionComponent={Transition}
          style={{maxWidth:'600px', margin:'auto'}}
          scroll='paper'
        >
          <div style={{width:'100%'}} className='shadow'>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <IconButton
                  onClick={ () => this.setState({filterOpen: false}) }
                >
                  <ArrowBackIosIcon />
                </IconButton>
                表示しない会員条件
              </div>
              <div style={{margin:'5px'}}>
                <Button
                  variant="outlined"
                  color='primary'
                  onClick={ async () => {
                    await this._filterEdit(false, '');
                    await this._nondisplayListGet(this.state.filter, 1);
                    await this.setState({filterOpen: false});
                  }}
                  size='small'
                >
                  条件をリセット
                </Button>
              </div>
            </div>
          </div>

          <DialogContent style={{padding:'10px'}}>
            <div>
              <div style={{padding:'3%'}}>
                <PartCheckbox
                  value={this.state.filter.outage}
                  checked={this.state.filter.outage}
                  click={ (e) => {
                    var outage = this.state.filter.outage ? false: true;
                    var name = this.state.filter.name;
                    this._filterEdit(outage, name);
                  }}
                >
                  <span>退会した会員のみを表示</span>
                </PartCheckbox>
              </div>
              <div style={{padding:'3%'}}>
                <h3>
                  名前
                </h3>
                <div style={{textAlign:'center'}}>
                  <input
                    value={this.state.filter.name}
                    onChange={
                      (e) => {
                        var outage = this.state.filter.outage;
                        var name = e.target.value;
                        this._filterEdit(outage, name);
                      }
                    }
                    style={{fontSize:'1.2em',width:'80%'}}
                    className={ "input_blue round6" }
                  />
                </div>
              </div>


            </div>

            <div style={{padding:'10px'}}>
              <Button
                variant="contained"
                color='primary'
                onClick={ () => {
                  this._nondisplayListGet(this.state.filter, 1);
                  this.setState({filterOpen: false});
                }}
                style={{width: '100%', fontSize:'1.2em'}}
              >
                検索する
              </Button>
            </div>
          </DialogContent>
        </Dialog>

      </div>
    )
  }
}
const mapStateToProps = (state) => {
	return {
    config: state.config,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...settingAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
